import type { Template } from "@/types";

export const SQ_04_H2_V2: Template[] = [
    {
        id: "sq-04-h2v2-01",
        name: "SQ 01 - H2V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h2_v2_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 46, y: 215, width: 190, height: 286, rotation: 0, imageRotation: 0 },
            { id: "2", x: 244, y: 215, width: 428, height: 286, rotation: 0, imageRotation: 0 },
            { id: "3", x: 766, y: 215, width: 428, height: 286, rotation: 0, imageRotation: 0 },         
            { id: "4", x: 1203, y: 215, width: 190, height: 286, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h2v2-02",
        name: "SQ 02 - H2V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h2_v2_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 45, y: 206, width: 203, height: 305, rotation: 0, imageRotation: 0 },
            { id: "2", x: 256, y: 206, width: 458, height: 305, rotation: 0, imageRotation: 0 },
            { id: "3", x: 721, y: 206, width: 458, height: 305, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1187, y: 206, width: 203, height: 305, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h2v2-03",
        name: "SQ 03 - H2V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h2_v2_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 195, width: 216, height: 326, rotation: 0, imageRotation: 0 },
            { id: "2", x: 223, y: 195, width: 489, height: 326, rotation: 0, imageRotation: 0 },
            { id: "3", x: 721, y: 195, width: 489, height: 326, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1218, y: 195, width: 215, height: 326, rotation: 0, imageRotation: 0 }
        ],
    },


    {
        id: "sq-04-h2v2-04",
        name: "SQ 04 - H2V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h2_v2_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 29, y: 29, width: 438, height: 659, rotation: 0, imageRotation: 0 },
            { id: "2", x: 474, y: 29, width: 490, height: 326, rotation: 0, imageRotation: 0 },
            { id: "3", x: 474, y: 362, width: 490, height: 326, rotation: 0, imageRotation: 0 },          
            { id: "4", x: 973, y: 29, width: 438, height: 659, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h2v2-05",
        name: "SQ 05 - H2V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h2_v2_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 168, y: 74, width: 381, height: 570, rotation: 0, imageRotation: 0 },
            { id: "2", x: 788, y: 74, width: 574, height: 306, rotation: 0, imageRotation: 0 },
            { id: "3", x: 788, y: 388, width: 390, height: 257, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1186, y: 388, width: 176, height: 257, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h2v2-06",
        name: "SQ 06 - H2V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h2_v2_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 480, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 788, y: 74, width: 574, height: 306, rotation: 0, imageRotation: 0 },
            { id: "3", x: 788, y: 387, width: 390, height: 257, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1186, y: 387, width: 176, height: 257, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h2v2-07",
        name: "SQ 07 - H2V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h2_v2_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 52, y: 55, width: 894, height: 610, rotation: 0, imageRotation: 0 },
            { id: "2", x: 955, y: 55, width: 429, height: 285, rotation: 0, imageRotation: 0 },
            { id: "3", x: 955, y: 347, width: 211, height: 318, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1174, y: 347, width: 210, height: 318, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h2v2-08",
        name: "SQ 08 - H2V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h2_v2_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 46, y: 257, width: 309, height: 206, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 257, width: 308, height: 206, rotation: 0, imageRotation: 0 },
            { id: "3", x: 763, y: 128, width: 309, height: 465, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1080, y: 128, width: 308, height: 465, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h2v2-09",
        name: "SQ 09 - H2V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h2_v2_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 133, y: 47, width: 453, height: 296, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 350, width: 223, height: 320, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 350, width: 223, height: 320, rotation: 0, imageRotation: 0 },
            { id: "4", x: 763, y: 147, width: 625, height: 424, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h2v2-10",
        name: "SQ 10 - H2V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h2_v2_10.png",
        size: [1434, 717],
        style: {},
        slots: [  
            { id: "1", x: 48, y: 127, width: 307, height: 463, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 127, width: 306, height: 463, rotation: 0, imageRotation: 0 },
            { id: "3", x: 902, y: 127, width: 347, height: 228, rotation: 0, imageRotation: 0 },
            { id: "4", x: 902, y: 363, width: 347, height: 227, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h2v2-11",
        name: "SQ 11 - H2V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h2_v2_11.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 50, y: 157, width: 597, height: 403, rotation: 0, imageRotation: 0 },    
            { id: "2", x: 654, y: 157, width: 130, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 654, y: 362, width: 130, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 791, y: 157, width: 597, height: 403, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h2v2-12",
        name: "SQ 12 - H2V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h2_v2_12.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 32, y: 125, width: 309, height: 468, rotation: 0, imageRotation: 0 },     
            { id: "2", x: 349, y: 237, width: 365, height: 245, rotation: 0, imageRotation: 0 },
            { id: "3", x: 722, y: 237, width: 364, height: 245, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1094, y: 125, width: 309, height: 468, rotation: 0, imageRotation: 0 }
        ],
    },



];